let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aYLJl")).then(() => parcelRequire('b9FSQ'));